import React, { useState, useEffect } from 'react';

const FadeIn = ({
  children,
  delay = 50,
  transitionDuration = 400,
  className = '',
  childClassName = '',
  wrapperTag: WrapperTag = 'div',
  childTag: ChildTag = 'div',
  visible = true,
  onComplete,
}) => {
  const [visibleChildren, setVisibleChildren] = useState([]);
  const childArray = React.Children.toArray(children);

  useEffect(() => {
    if (!visible) {
      setVisibleChildren([]);
      return;
    }

    let timeouts = [];
    childArray.forEach((_, index) => {
      const timeout = setTimeout(() => {
        setVisibleChildren((prev) => [...prev, index]);

        // Call onComplete when all children are visible
        if (index === childArray.length - 1 && onComplete) {
          setTimeout(onComplete, transitionDuration);
        }
      }, index * delay);
      timeouts.push(timeout);
    });

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [visible, childArray.length, delay, transitionDuration, onComplete]);

  const childStyle = (index) => ({
    opacity: visibleChildren.includes(index) ? 1 : 0,
    transition: `opacity ${transitionDuration}ms ease-in-out`,
  });

  return (
    <WrapperTag className={className}>
      {childArray.map((child, index) => (
        <ChildTag
          key={index}
          className={childClassName}
          style={childStyle(index)}
        >
          {child}
        </ChildTag>
      ))}
    </WrapperTag>
  );
};

export default FadeIn;
